import { gql } from "@apollo/client";

const GET_REMITOS_BNP = gql`
    query remitosBNP($idEvaluacion: Int!) {
        remitosBNP(idEvaluacion: $idEvaluacion) {
            success,
            error,
            valorEsperado {
              idRemito
              fecha
              origen
              numeroRemito
              tieneDocumento
            }
        }
    }
`;

export default GET_REMITOS_BNP;

export const adaptRemitoBNP = (remito) => {
  return {
    idRemito: remito?.idRemito,
    fecha: remito?.fecha,
    origen: remito?.origen,
    numeroRemito: remito?.numeroRemito,
    tieneDocumento: remito?.tieneDocumento ? 1 : 0
  };
};

export const adaptRemitosBNPArray = (remitos) => {
  return structuredClone(remitos)?.
  map((remito) => adaptRemitoBNP(remito));
};